import { Button } from '@mantine/core';
import { ButtonProps } from '@mantine/core';

interface SubscribeButtonProps extends ButtonProps {
    onClick: () => void;
}

export const SubscribeButton = ({ onClick, ...props }: SubscribeButtonProps) => (
    <Button onClick={onClick} {...props}>
        Subscribe
    </Button>
);